import React from 'react';
import { Column } from "rbx";
import Layout from "../../layout";
import PdvFindForm from '../../../components/pdv/find_form';

const PdvFindScreen = () => {

  return (
    <Layout>
      <Column.Group centered>
        <Column size={4}>
          <PdvFindForm />
        </Column>
      </Column.Group>
    </Layout>
  )

}

export default PdvFindScreen;

